import { render } from "./SustainabilityOverview.vue?vue&type=template&id=61856556&scoped=true"
import script from "./SustainabilityOverview.vue?vue&type=script&lang=js"
export * from "./SustainabilityOverview.vue?vue&type=script&lang=js"

import "./SustainabilityOverview.vue?vue&type=style&index=0&id=61856556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61856556"]])

export default __exports__